import type * as Hex from 'ox/Hex'
import { legacy } from './legacy.js'

export function getHeadlessSignPayloadOptions(challenge: Hex.Hex) {
  return {
    challenge,
    origin: legacy.headlessWebAuthnOrigin,
    rpId: legacy.headlessWebAuthnRpId,
  } as const
}
